
{
  "fr": {
    "configuratorFooter": {
      "title": "Récapitulatif",
      "error": "Vous devez renseigner tous les champs de personnalisation.",
      "action": {
        "goNext": {
          "addToCart": "Commander",
          "addToCartLoading": "En cours..."
        }
      }
    }
  }
}
